import settings from "../utils/settings";
import SFError from "../models/SfError";
//import { useDataProvider } from "ra-core";
const useEditTransaction = () => {
  //const dataprovider = useDataProvider();
  const editTransaction = async ({ id, version, image }) => {
    const { lang, token } = settings();

    try {
      let formData = new FormData();
      formData.append("lang", lang);
      // formData.append("realm_id", realmId);
      // formData.append("branch_id", branchId);
      formData.append("action", "upload_image");
      formData.append("image", image);
      formData.append("__v", version);
      let options = {
        method: "PATCH",
        body: formData,
        headers: {
          Authorization: `Bearer ${token}`,
        },
      };
      delete options.headers["Content-Type"];

      const result = await fetch(
        `${process.env.REACT_APP_API_ENDPOINT}/transactions/${id}`,
        options
      );

      if (result.ok) {
        return [true, null];
      } else {
        return [null, "Error"];
      }
      // const result = await dataprovider.update("transactions", {
      //   data: {
      //     id: id,
      //     locale: lang,
      //     realm_id: realmId,
      //     branch_id: branchId,
      //     image,
      //     __v: version,
      //   },
      // });
    } catch (error) {
      const sfError = new SFError({ message: String(error) });
      return [null, sfError];
    }
  };
  return { editTransaction };
};

export default useEditTransaction;
